import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

function CInfoLangue()  { 
  const paysIni = useSelector(state => state.ComPays)
  const regionIni = useSelector(state => state.ComRegion)
  const dispatch = useDispatch()
  const [showlangue, setShowLangue]=useState(false)
  const [objregioninfo, SetObjregioninfo] = useState({
        code: "",        
        sourceinfo: "",
        dateCreation: "",
        bulletinPdf: null,
        bulletinImage: null,
        bulletinAudio: null,
        alertMessage: "",
        pays: ""
    });
  const [selectLangue, setSelectLangue] = useState("");
  const[query, SetQuery] = useState("");
  
  
  const onSelect = (event) =>{      
      setSelectLangue(event.target.value);
      setShowLangue(false);          
                
    }
    
    const actionbouton = () => {
          dispatch({ 
                  type:"ComLangue/sendLangue",
                  payload: selectLangue
                  }); 

          setShowLangue(true)  
          console.log({selectLangue}) ;   
        //  console.log(selectRegion);         
    }
 
  ///let paramPays ='';
  /// paramPays = paysIni.codepays;
  const urlgetregioninfo = `https://eagrimet.online/eagrimetApi/regionInfo/?code=${regionIni.coderegion}`
  const  axiosconfig = {
        headers: {
        "Content-Type": "application/json",
        "Authorization": "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
                 
        }
     };

   useEffect( () => {
        const cherchregioninfo = async() =>{
            await axios.get(urlgetregioninfo, axiosconfig)           
           .then((resultat) => {
               let result = resultat.data.map(r => {
                        Object.assign(objregioninfo, r) 
                        SetObjregioninfo({...objregioninfo,  sourceinfo : r.sourceinfo, alertMessage : r.alertMessage, pays: r.pays})                                           
                        })   
                console.log(objregioninfo)
                console.log( typeof(resultat.data) , "resultat region info");
             }
            ) 
           .catch((err) => console.log(err));  
        };
        cherchregioninfo()
     }, [regionIni.coderegion])  

    return (
      <div className='row'>
        <div className='col-6' hidden>                
              {
                  objregioninfo.bulletinPdf !== null &&
                  <a href={objregioninfo.bulletinPdf} target='_blank' rel="noreferrer"> 
                      Bulletin
                  </a>  
              }
        </div>
            
        <div className='col-6'>
            {objregioninfo.bulletinAudio !== null &&                          
                <iframe src={objregioninfo.bulletinAudio} frameborder="0" height="30px"></iframe>
            }
           
           
        </div>
         

      </div>
    )
}

export default CInfoLangue ;